// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2xjsg","rootSuccess":"CompleteLink_rootSuccess__uwcIA","rootFailure":"CompleteLink_rootFailure__2z7Cr","isDisabled":"CompleteLink_isDisabled__15liU"};